import { Clickable, Col, HighlightsSlider, Icon, LiveStream, Row, Text } from 'components';
import { addHours } from 'date-fns';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import { Item } from './components';

const Highlights = ({ type, noMarg }) => {
  const [data, setData] = useState([]),
    [stream, setStream] = useState(null),
    [offset, setOffset] = useState(0),
    [index, setIndex] = useState(undefined),
    stories = useSelector((state) => state.home?.stories),
    { isMobile } = useSelector((state) => state.appState),
    { t } = useTranslation(),
    navigate = useNavigate(),
    mappedStories = data.filter((x) => x.recent);

  useEffect(() => {
    if (!stories?.length) return;

    const mapped = stories
      .map((x) => {
        if (x.streamKey) return x;

        const filteredRecents = x.recent.filter((y) => {
          const shouldDissapearAt = addHours(new Date(y.createdAt), 48);

          return new Date() < shouldDissapearAt;
        });

        if (!filteredRecents.length) return null;

        return {
          ...x,
          recents: filteredRecents
        };
      })
      .filter((x) => x && x.ownerType === type)
      .sort((a, b) => !!b.streamKey || new Date(b.updatedAt) - new Date(a.updatedAt));

    setData(mapped);
  }, [stories]);

  function handleClick(index) {
    if (index === undefined) {
      setIndex(index);
      setStream(null);
      return;
    }

    const item = data[index];

    if (item.streamKey) {
      return setStream(item);
    }

    const idx = mappedStories.findIndex((x, i) => {
      return x._id === data[index]._id;
    });

    setIndex(idx);
  }

  if (!data?.length) return null;

  return (
    <Col noFlex wid={isMobile ? '100vw' : 'unset'}>
      <Text h2 marg={isMobile && '0 0 0 16px'}>
        {t(type === 'athlete' ? 'home.athleteHighlights' : 'home.fanHighlights')}
      </Text>

      <Row
        wid={isMobile ? '100vw' : '936px'}
        ht="92px"
        start
        marg={isMobile ? '8px 0 0' : '16px 0 0'}
        pos="relative"
        style={{ overflowX: 'hidden' }}
        hideScrollBar
        hideS
      >
        {offset !== 0 && !isMobile && (
          <Col pos="absolute">
            <div
              style={{
                background: 'linear-gradient(to left, rgba(0,0,0,0), rgba(255,255,255,1))',
                width: 32,
                height: 92
              }}
            />
            <Row pos="absolute" wid="32px" ht="32px" bg="#000" top="22px" hasRadius="32px">
              <Clickable wid="100%" ht="100%" onClick={() => setOffset(offset - 1)}>
                <Row centerAll ht="100%">
                  <Icon type="leftChevron" col="#fff" dimensions={12} />
                </Row>
              </Clickable>
            </Row>
          </Col>
        )}

        {offset + 1 < data.length / 10 && !isMobile && (
          <Col pos="absolute" right="0">
            <div
              style={{
                background: 'linear-gradient(to right, rgba(0,0,0,0), rgba(255,255,255,1))',
                width: 32,
                height: 92
              }}
            />
            <Row pos="absolute" wid="32px" ht="32px" bg="#000" top="22px" hasRadius="32px">
              <Clickable wid="100%" ht="100%" onClick={() => setOffset(offset + 1)}>
                <Row centerAll ht="100%">
                  <Icon type="rightChevron" col="#fff" dimensions={12} />
                </Row>
              </Clickable>
            </Row>
          </Col>
        )}

        <Row
          gap="16px"
          marg={`0 0 0 ${-offset * 960}px`}
          pad={`0 0 0 ${isMobile * 16}px`}
          hideScrollBar
          style={{
            overflowX: isMobile ? 'scroll' : 'hidden',
            transition: 'margin 1s'
          }}
        >
          {data.map((x, i) => (
            <Item
              item={x}
              key={i}
              index={i}
              data={data}
              navigate={navigate}
              onClick={handleClick}
            />
          ))}
        </Row>
      </Row>

      <HighlightsSlider
        data={mappedStories}
        startingIndex={index}
        closeModal={() => handleClick(undefined)}
        visible={typeof index === 'number'}
      />

      <LiveStream
        data={stream}
        closeModal={() => handleClick(undefined)}
        visible={stream !== null}
      />
    </Col>
  );
};

export default Highlights;
